import { api } from "./apiConfig";

export const getClient = async (id) => {
  const { data } = await api.get(`/client/${id}`);
  return data;
};

export const getClients = async (params) => {
  const { page = 1, limit = 10, search = "", archived } = params;
  const apiParams = { page, limit, search };
  if (archived !== undefined) {
    apiParams.archived = archived;
  }
  const { data } = await api.get("/client", { params: apiParams });
  return data;
};

export const patchClient = async ({ id, data }) => {
  await api.patch(`/client/${id}`, { id, ...data });
};

export const saveClient = async (data) => {
  const { data: responseData } = await api.post("/client", data);
  return responseData;
};
